import AttachmentsCollection from "../../../attachment/attachments"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"

/**
 * The contact's files, as ApiCRM.getContactV3 returns them.
 *
 * GOTCHA: the GraphQL Attachment type names two fields differently from the Attachment model -
 * `mimeType` is the model's `mime`, and `userId` (who uploaded it) is its `createdByUserId`.
 * Passing the records through untouched leaves both undefined.
 */
export default function initCrmContactAttachments(records: any[]): AttachmentsCollection {

    const attachments = _.map(records ?? [], (record: any)=> ({
        ...record,
        mime            : record.mimeType,
        createdByUserId : record.userId,
        momentCreated   : DatetimeUtils.datetimeToMoment(record.momentCreated),
    }))

    return new AttachmentsCollection(attachments)
}
